module.exports = __webpack_public_path__ + "img/visa.68d0177.svg";